import { useState } from 'react';
import { Enviroment } from '../../../../../_config/constants/enviroment-v2.constant';
import CustomButton from '../../../../../v2-components/Antd/Button';
import CustomDivider from '../../../../../v2-components/Antd/Divider';
import CustomModal from '../../../../../v2-components/Antd/Modal';
import CustomSelect from '../../../../../v2-components/Antd/Select';
import CustomTextArea from '../../../../../v2-components/Antd/TextArea';
import { selectQfConstants } from './constants/select-qf.constant';
import { selectConstants } from './constants/select.constant';
import { checkRecipe } from './handle/check-recipe.handle';
import { hideApproveButton } from './handle/hide-approve-button.handle';
import { hideRejectButton } from './handle/hide-reject-button.handle';
import { recipeStatus } from './handle/recipe-status.handle';
import { qfHistoryAdapter } from './handle/qf-history-adapter.handle';
import { rejectHistoryAdapter } from './handle/reject-history-adapter.handle';
import { showRecipeButtons } from './handle/show-recipe-buttons.handle';
import './style.css';

export default function RecipeModal(props) {
	console.log('modal receta',props);
	const [openRejectModal, setOpenRejectModal] = useState(false);
	const [openQfModal, setOpenQfModal] = useState(false);
	const [rejectReason, setRejectReason] = useState();
	const [approveQfReason, setApproveQfReason] = useState();
	const [observations, setObservations] = useState(null);
	const [observationsQf, setObservationsQf] = useState(null);

	const qfHistory = qfHistoryAdapter(props);

	const handleRejectModalClose = () => {
		setOpenRejectModal(false);
		setRejectReason(null);
		setObservations(null);
	};

	const handleQfModalClose = () => {
		setOpenQfModal(false);
		setApproveQfReason(null);
		setObservations(null);
	};

	const handleRejectReason = (e) => {
		setRejectReason(e);
	};

	const handleQf = (e) => {
		setApproveQfReason(e);
	};

	const handleTextAreaReject = (e) => {
		setObservations(e.target.value);
	};

	const handleTextAreaQf = (e) => {
		setObservationsQf(e.target.value);
	};

	const handleApproveQfRecipe = async () => {
		await props.handleApproveQf(approveQfReason, observationsQf);
		setOpenQfModal(false);
	};

	const handleRejectRecipe = async () => {
		await props.handleReject(rejectReason, observations);
		setRejectReason(null);
		setObservations(null);
		setOpenRejectModal(false);
	};

	console.log('reject reason',rejectReason)
	const renderButtons = () => {
		return (
			<>
				<h5>Historial</h5>
				{rejectHistoryAdapter(props.recipeInfo?.observation_reject_recipe, qfHistory)}

				{Enviroment.COUNTRY !== 'MX' && (
					<CustomButton style={hideApproveButton(props.recipeInfo?.validation_product)} onClick={() => setOpenQfModal(true)}>
						APROBADO POR QF
					</CustomButton>
				)}
				<CustomButton style={hideRejectButton(props.recipeInfo?.validation_product)} onClick={() => setOpenRejectModal(true)}>
					RECHAZAR RECETA
				</CustomButton>
				<CustomButton style={hideApproveButton(props.recipeInfo?.validation_product)} onClick={props.handleApproveRecipe}>
					APROBAR RECETA
				</CustomButton>
			</>
		);
	};

	return (
		<>
			<CustomModal onCancel={() => props.setOpenRecipe(false)} footer={null} open={props.openRecipe}>
				<h2>Receta adjunta</h2>
				<CustomDivider />
				<h3>Producto</h3>
				<p>{props.recipeInfo?.name}</p>
				<h4>{recipeStatus(props.recipeInfo?.validation_product)}</h4>
				<CustomDivider />
				{props.recipeInfo?.patient && (
					<>
						<h3>Paciente</h3>
						<p><strong>Nombre:</strong> {props.recipeInfo.patient.first_name} {props.recipeInfo.patient.last_name}</p>
						<p><strong>RUT:</strong> {props.recipeInfo.patient.rut}</p>
						<CustomDivider />
					</>
				)}
				{checkRecipe(props.recipe)}
				<CustomDivider />
				{showRecipeButtons(props.status, renderButtons, props.setOpenRecipe)}
			</CustomModal>

			<CustomModal onCancel={handleRejectModalClose} footer={null} open={openRejectModal}>
				<h2>Rechazar receta</h2>
				<h2>Seleccionar motivo de rechazo</h2>
				<CustomSelect
					placeholder={'Seleccionar motivo'}
					options={selectConstants[Enviroment.LANGUAGE]}
					style={{ width: '100%', marginBottom: '10px' }}
					onChange={handleRejectReason}
				/>
				<CustomTextArea placeholder={'Observaciones'} onChange={handleTextAreaReject} style={{ marginBottom: '10px' }} />
				<CustomButton onClick={handleRejectModalClose}>Cancelar</CustomButton>
				<CustomButton onClick={handleRejectRecipe}>Rechazar</CustomButton>
			</CustomModal>

			<CustomModal onCancel={handleQfModalClose} footer={null} open={openQfModal}>
				<h2>Aprobar receta</h2>
				<h2>Seleccionar motivo</h2>
				<CustomSelect
					placeholder={'Seleccionar motivo'}
					options={selectQfConstants[Enviroment.LANGUAGE]}
					style={{ width: '100%', marginBottom: '10px' }}
					onChange={handleQf}
				/>
				<CustomTextArea placeholder={'Observaciones'} onChange={handleTextAreaQf} style={{ marginBottom: '10px' }} />
				<CustomButton onClick={handleQfModalClose}>Cancelar</CustomButton>
				<CustomButton onClick={handleApproveQfRecipe}>Aprobar</CustomButton>
			</CustomModal>
		</>
	);
}
